import { getRootDomain } from "environments/environment-helpers";

export const pouchConfig_prod = {
  couch_serverurl: `https://couch-prod.db.${getRootDomain()}/`,
};
